import {ReadonlyDeep} from 'type-fest';
import {
  WorkerEntity,
  WorkerType,
} from '../../universal/features/api/entity/dashboard/worker/WorkerEntity';

export default (_: ReadonlyDeep<WorkerEntity>) =>
  !_.pool_miner_is_active && _.worker_type === WorkerType.Pool && !_.expired;
